import { ReactComponent as ActivityIcon } from "assets/svgs/activity.svg";
import { ReactComponent as DashboardWhite } from "assets/svgs/dashboard-white.svg";
import { ReactComponent as LogoutOff } from "assets/svgs/logout-off.svg";
import { ReactComponent as LogoutOn } from "assets/svgs/logout.svg";
import { ReactComponent as MDAWhite } from "assets/svgs/mda-white.svg";
import { ReactComponent as PersonIcon } from "assets/svgs/person.svg";
import { ReactComponent as WorkbenchWhite } from "assets/svgs/workbench-white.svg";

import { ReactNode } from "react";
import { NavigateFunction } from "react-router-dom";
import { AuthPaths, SuperAdminPaths } from "routes/paths";
import { logOut } from "utils/auth";
import { Roles, Modules } from "../modules/Admin/constants/personnel";

export interface INavItem {
  name: string;
  url: (data?: any) => string;
  icon: (active: boolean) => ReactNode;
  subNav?: INavItem[];
  onClick?: (navi: NavigateFunction) => void;
  bottom?: boolean;
  roles?: string[];
  modules?: string[];
}

export const SUPER_ADMIN_NAV_ITEMS = [
  {
    name: "Instances",
    url: () => SuperAdminPaths.INSTANCES,
    icon: (active: boolean) => <PersonIcon />,
    roles: [Roles.SUPERADMIN],
  },
];

export const LOGOUT_NAV = {
  name: "Logout",
  url: () => "",
  icon: (superAdmin: boolean) => (superAdmin ? <LogoutOff /> : <LogoutOn />),
  onClick: (navigate: any) => logOut(() => window.open(AuthPaths.SIGNIN, "_self")),
  modules: [Modules.DMM, Modules.GMM],
};

export const TEMPLAT_LOGOUT_NAV = {
  name: "Logout",
  url: () => "",
  icon: (superAdmin: boolean) => (superAdmin ? <LogoutOff /> : <LogoutOn />),
};
export const TEMPLATE_ITEMS = [
  {
    name: "Dashboard",
    url: () => "",

    icon: (active: boolean) => <DashboardWhite />,

    bottom: false,
  },
  {
    name: "Activities",
    url: () => "",

    icon: (active: boolean) => <ActivityIcon />,

    bottom: false,
  },
  {
    name: "Workbench",
    url: () => "",

    icon: (active: boolean) => <WorkbenchWhite />,

    bottom: false,
  },
  {
    name: "Audit Log",
    url: () => "",

    icon: (active: boolean) => <WorkbenchWhite />,

    bottom: false,
  },
  {
    name: "MDA",
    url: () => "",
    icon: (active: boolean) => <MDAWhite />,

    bottom: false,
  },
];
